'use client';

import { use, useEffect } from 'react';

import { Breadcrumbs, BreadcrumbsContext, BreadcrumbsItem } from '..';

type BreadcrumbListProps = {
	list: BreadcrumbsItem[];
	className?: string;
	withBg?: boolean;
	hideOnMobile?: boolean;
	refPage?: string;
};

export function BreadcrumbList({
	list,
	refPage,
	...props
}: BreadcrumbListProps) {
	const { setList, setRefPage } = use(BreadcrumbsContext);
	useEffect(() => {
		setList(list);
		setRefPage(refPage ?? '');
		return () => {
			setList([]);
			setRefPage('');
		};
	}, [list, setList, refPage, setRefPage]);

	return <Breadcrumbs {...props} />;
}
